export const extractHoursAndMinutes = (
  fullDateString: string
): string | null => {
  if (fullDateString) {
    const [, onlyTime] = fullDateString.split('T');
    const [hours, minutes] = onlyTime.split(':');

    return `${hours}:${minutes}`;
  } else {
    return null;
  }
};
